export default {
  // ? ==========================
  // ? =====  Multilocation  ====
  // ? ==========================

  multiLocation: {},

  // ? ===================
  // ? =====  Layout  ====
  // ? ===================

  navigation: {
    '.logoLocationContainer': {
      padding: '0rem',
      height: 'unset'
    },
    '.logo': {
      a: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      img: {
        maxHeight: ['100px', '125px', '125px', '125px']
      }
    },
    '.logoScrolled': {
      display: 'flex',
      height: 'auto',
      maxHeight: 'unset',

      a: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      img: {
        maxHeight: ['80px', '100px', '100px', '100px']
      }
    },

    '.container': {
      backgroundColor: 'white',
      padding: '0rem 0rem',
      height: 'auto',
      borderBottom: 'solid 2px grey'
    },
    '.containerScrolled': {
      borderBottom: 'solid 1px',
      borderColor: 'primary',
      backgroundColor: 'light',
      padding: '0rem 0rem',
      height: 'auto',
      borderBottom: 'solid 2px grey'
    },

    '.smallNavMenu': {
      justifyContent: 'center',
      padding: '0rem 2rem',

      '.navItem': {
        color: 'primary',
        a: {
          fontSize: '1rem',
          fontFamily: 'body',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          ':hover': {
            textDecoration: 'underline',
            color: 'grey'
          }
        }
      }
    },

    '.hamburger': {
      borderRadius: '10px',
      display: ['', '', '', 'none'],
      '> div': {
        backgroundColor: 'primary'
      }
    },
    '.hamburgerOpen': {
      borderColor: 'white',
      '> div': {
        backgroundColor: 'primary'
      }
    },

    '.navMenuLogo': {
      display: 'none'
    },

    // '.phoneContainer': {
    //   display: 'flex',
    //   border: 'none',
    //   margin: '0rem 1rem',
    //   justifyContent: 'flex-end',
    //   alignItems: 'flex-end',
    //   a: {
    //     backgroundColor: 'primary',
    //     padding: '0.5rem',
    //     color: 'light',
    //     textAlign: 'center',
    //     margin: '0.5rem 0rem',
    //   },
    // },
    '.navMenuOpen': {
      alignItems: ['', '', '', 'flex-end'],
      padding: ['', '', '', '4rem'],
      width: '80%',
      maxWidth: '500px',
      backgroundColor: 'primary',
      '.navItem': {
        a: {
          color: 'light',
          ':hover': {
            textDecoration: 'underline'
          }
        }
      },
      '.seperatorLine': {
        margin: ['', '', '', '1rem 0 1rem auto']
      },
      '.phoneSocialContainer': {
        flexDirection: ['', '', '', 'column'],
        alignItems: ['', '', '', 'flex-end'],
        textAlign: ['', '', '', 'right'],
        a: {
          textAlign: ['', '', '', 'right'],
          justifyContent: ['', '', '', 'flex-end'],
          fontSize: '1rem'
        }
      },
      '.smallNavHeading ': {
        textAlign: ['', '', '', 'right'],
        color: 'white'
      },

      '.socialIconsContainer': {
        alignItems: ['', '', '', 'flex-end'],
        textAlign: ['', '', '', 'right'],
        '.smallNavHeading ': {
          textAlign: 'right'
        },
        a: {
          textAlign: ['', '', '', 'right'],
          justifyContent: ['', '', '', 'flex-end'],
          fontSize: '1rem',
          svg: {
            path: {
              fill: 'white'
            }
          }
        }
      }
    }
  },

  footer: {
    backgroundColor: 'primary',
    borderTop: 'solid 2px',
    borderColor: 'primary',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ['0.5rem 0.5rem 6rem', '', '0.5rem 3rem'],
    '.image': {
      // filter: 'brightness(0) invert(1)',
      display: 'none'
    },
    '.multiButtonContainer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      a: {
        width: 'fit-content'
      }
    },
    '.contactDetails-container': {
      // display: 'none',
      color: 'white'
    },
    '.copyright': {
      width: '50%',
      color: 'white',
      textAlign: 'center'
    },
    '.socialIconsContainer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '1rem',
      a: {
        svg: {
          width: '40px',
          height: '40px',
          padding: '0.5rem',
          border: 'solid 1px white',
          borderRadius: '100px',
          ':hover': {
            backgroundColor: 'grey'
          }
        },
        margin: '0.5rem'
      }
    },
    '.gonationLogo': {
      width: '50%'
    }
  },

  ctaWidget: {},

  // ? ====================
  // ? ==== Reuseables ====
  // ? ====================

  title: {
    fontSize: ['2rem', '2.5rem', '3rem', '3.5rem', '3.5rem'],
    fontWeight: 'normal',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'left',
    marginBottom: '1.5rem',
    order: '1',
    textTransform: 'uppercase'
  },
  subtitle: {
    width: 'fit-content',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: ['1.1rem', '1.2rem', '1.5rem'],
    marginBottom: '1.5rem',
    order: '2',
    border: 'none',
    fontFamily: 'body',
    color: '#767676',
    fontWeight: '300'
  },
  text: {
    lineHeight: '1.75',
    order: '3',
    p: {
      lineHeight: '1.75',
      fontSize: 'inherit',
      textAlign: 'left'
    }
  },

  sideBySide1: {
    padding: '0rem',
    margin: '2rem 5%',
    '.lazyload-wrapper': {
      maxHeight: '75vh',
      justifyContent: 'flex-end'
    },
    '.content': {
      position: 'relative',
      alignItems: 'flex-start',
      margin: ['1rem 0rem', '', '0rem'],
      backgroundColor: '#f5fbff',
      marginRight: ['', '', '2rem']
    },
    '.title': {
      variant: 'customVariants.title'
    },
    '.subtitle': { variant: 'customVariants.subtitle' },
    '.text': {
      variant: 'customVariants.text'
    },
    a: {
      order: '5'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },

  sideBySide2: {
    variant: 'customVariants.sideBySide1',
    '.content': {
      position: 'relative',
      alignItems: 'flex-start',
      margin: ['1rem 0rem', '', '0rem'],
      backgroundColor: '#f5fbff',
      marginLeft: ['', '', '2rem']
    }
  },

  homepageBlock: {
    marginTop: '1rem',
    '.section': {
      margin: 'auto auto auto 4rem',
      padding: '0.5rem',
      alignItems: 'flex-start',
      maxWidth: ['', '', '', '55%']
    },
    '.title': {
      variant: 'customVariants.title',
      fontSize: ['2rem', '2.5rem', '3rem', '3.5rem', '4rem'],
      border: 'none',
      margin: '0rem 0rem 1rem',
      padding: '0rem',
      textAlign: 'left',
      color: 'white'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      width: '100%',
      textAlign: 'left',
      color: 'white'
    },
    '.text': {
      variant: 'customVariants.text',
      color: 'white',
      textAlign: 'left',
      p: {
        color: 'white',
        textAlign: 'left'
      }
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },

  sliderPageHero: {
    height: '80vh',
    '.slick-slider, .slick-list, .slick-slide, .slick-slide > div, .slick-slide img': {
      height: '80vh'
    },

    '.hero_content_container': {
      left: '50%',
      transform: 'translate(-50%,-50%)',
      color: 'white',
      margin: '0rem',
      '.title': {
        variant: 'customVariants.title',
        marginBottom: '0rem'
      }
    }
  },

  // ? ====================
  // ? ====  Homepage  ====
  // ? ====================

  homepageHero: {
    height: '80vh',
    '.title': {
      variant: 'customVariants.title',
      color: 'white',
      textShadow: '2px 2px 4px #000000'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      order: '3',
      color: 'lightgrey',
      display: 'none'
    },
    '.text': {
      variant: 'customVariants.text',
      display: 'none'
    },
    a: {
      order: '5',
      display: 'none'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    },

    '.slick-slider, .slick-list, .slick-slide, .slick-slide > div, .slick-slide img': {
      height: '80vh'
    }
  },

  homepageHeroShout: {
    display: 'none !important'
  },

  homepageAbout: {
    variant: 'customVariants.homepageBlock'
  },
  homepageMenu: {
    variant: 'customVariants.sideBySide1'
  },

  homepageOrder: {
    margin: 'calc(5% - 1rem)',
    padding: '0rem',
    '.box': {
      position: 'relative',
      padding: '3rem 2rem',
      minHeight: '350px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '1rem',
      width: ['100%', '', 'calc(50% - 2rem)']
    },
    '.image': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: '-1'
    },
    '.title': {
      variant: 'customVariants.title',
      fontSize: ['1.5rem', '', '1.75rem', '2.25rem', '2rem'],
      textTransform: 'capitalize',
      border: 'none',
      textAlign: 'center',
      color: 'white',
      backgroundColor: '#0c324e99',
      padding: '1.5rem',
      fontFamily: 'body',
      border: 'solid #a3981a 4px'
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      color: 'white'
    },
    '.text': {
      variant: 'customVariants.text',
      color: 'white'
    },
    a: {
      order: '5'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },
  homepageBanquets: {
    variant: 'customVariants.sideBySide2'
  },
  homepageWedding: {
    variant: 'customVariants.sideBySide1'
  },

  homepageGallery: {
    variant: 'customVariants.sideBySide2'
  },

  homepageEvents: {
    variant: 'customVariants.sideBySide1'
  },

  homepageContact: {
    variant: 'customVariants.homepageBlock'
  },

  homepageShout: {
    backgroundColor: 'background',
    padding: ['0rem', '', '', '0rem'],
    // margin: ['', '', '', '-7rem 5% 5%'],
    boxShadow: '0 0 15px rgb(0 0 0 / 20%)',
    position: 'relative',
    flexDirection: 'column',
    '.title': {
      backgroundColor: 'white',
      width: ['', '', '80%'],
      padding: ['0.5rem', '', '2rem 2rem 1rem'],
      textTransform: 'Capitalize',
      color: 'text',
      width: ['70%'],
      fontFamily: 'heading',
      fontWeight: 'normal',
      borderLeft: '10px solid #a3981a',
      fontSize: '2rem'
    },
    '.text': {
      fontFamily: 'heading',
      order: ['4', '', '3'],
      backgroundColor: 'white',
      fontWeight: 'normal',
      padding: ['0.5rem', '', '0rem 2rem'],
      color: 'text',
      width: ['70%'],
      color: '#4d4d4d',
      fontFamily: 'body',
      borderLeft: '10px solid #a3981a',
      fontSize: '1.1rem'
    },
    '.date': {
      backgroundColor: 'white',
      color: 'text',
      fontSize: '0.8rem',
      order: '5',
      padding: ['0.5rem', '', '1rem 2rem 2rem'],
      width: ['70%'],
      maxWidth: 'unset',
      borderLeft: '10px solid #a3981a'
    },
    '.imageContainer': {
      backgroundColor: 'white',
      position: 'absolute',
      left: '70%',
      height: '100%',
      width: '30%',
      order: ['', '', '4'],
      cursor: 'pointer',
      color: 'text'
    },
    '.shoutCTABtns': {
      backgroundColor: 'white',
      width: ['70%', '70%', '70%', '70%'],
      a: {
        writingMode: 'unset'
      },
      'a:nth-of-type(2)': {
        opacity: '0.8'
      }
    }
  },

  // ? ========================
  // ? =====  Venue page  =====
  // ? ========================

  venueRestaurant: {
    variant: 'customVariants.sideBySide1'
  },
  venueOutdoor: {
    variant: 'customVariants.sideBySide1'
  },
  venueBar: {
    variant: 'customVariants.sideBySide1'
  },

  // ? ========================
  // ? =====  About page  =====
  // ? ========================

  aboutSection: {
    '.title': {
      borderBottom: '2px solid',
      borderColor: 'primary'
    }
  },

  // ? ========================
  // ? ====  Menu page  ====
  // ? ========================

  menu: {},

  // ? ========================
  // ? ====  Gallery page  ====
  // ? ========================

  gallery: {
    '.albumTitle': {
      padding: '0.5rem'
    },
    '.sauces ': {
      '.albumImage': {
        objectFit: 'contain',
        gridRowEnd: 'span 2'
      }
    }
  },

  // ? ========================
  // ? ====  Events page  ====
  // ? ========================

  events: {
    '.events-container': {
      maxWidth: 'unset'
    },
    '.no-events-container': {
      padding: '10rem 1rem',
      img: {
        maxHeight: '70px'
        // filter: 'brightness(0) invert(1)',
      }
    },

    '.eventItemDateContainer, .eventTime': {
      display: 'none'
    },

    '.eventItemImage': {
      minHeight: 'unset',
      width: '25%'
      // height: '100%',
    },
    '.eventDays, .eventDate': {
      color: 'primary'
    },
    '.eventItemDescription': {
      maxHeight: '250px',
      overflowY: 'scroll',
      '::-webkit-scrollbar': {
        display: 'none'
      },
      '-ms-overflow-style': 'none' /* IE and Edge */,
      scrollbarWidth: 'none'
    }
  },

  // ? ========================
  // ? ====  Contact page  ====
  // ? ========================

  contactForm: {
    display: 'none!important', // ! Remove contact form per customert
    order: '4',
    h2: {
      variant: 'customVariants.title',
      order: 'unset',
      fontSize: ['1.75rem', '2rem', '2rem', '2.5rem']
    },
    '.text': {
      color: 'white'
    },
    backgroundPosition: 'center center',
    color: 'white',
    backgroundColor: 'secondary',
    padding: ['3rem 1rem', '', '6rem 1rem'],
    '.inputField, .textField ': {
      fontWeight: '300',
      borderColor: 'white',
      borderWidth: '2px',
      borderRadius: '0px',
      padding: '1rem 0.5rem',
      color: 'white',
      '::placeholder': {
        color: 'white'
      }
    },

    '.submitBtn': {
      variant: 'buttons.secondary',
      height: 'unset',
      width: 'auto'
    }
  },

  locationMap: {
    order: '3',
    '.content_container': {
      padding: '0rem'
    },
    h3: {
      variant: 'customVariants.title',
      justifyContent: 'center',
      display: 'flex',
      order: 'unset',
      width: '100%',
      backgroundColor: 'secondary',
      padding: '0.5rem 0.5rem 1rem',
      textAlign: 'center',
      fontSize: ['1.75rem', '2rem', '2rem', '2.5rem'],
      textAlign: 'center',
      alignItems: 'center'
    },
    '.contactDetails-container': {
      padding: '0rem 1rem 3rem'
    },
    '.hours-section': {
      maxWidth: 'unset',
      padding: '0rem',
      '.hoursContainer': {
        padding: ['1rem', '2rem', '3rem 4rem', '3rem 5rem']
      }
    },
    '.dayofWeekText': {
      margin: '0 auto 1rem 0',
      borderBottom: '1px solid'
    },
    '.textContent': {
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      display: 'flex'
    }
  },

  // ? ========================
  // ? ====  Press page  ====
  // ? ========================

  pressMenu: {
    padding: ['1rem', '1rem', '1rem', '1rem'],
    backgroundColor: 'background',
    '.textContent': {
      backgroundColor: 'black'
    },
    '.imageContainer': {
      backgroundColor: '#8a7d74',
      img: {
        objectFit: 'contain',
        padding: '1rem'
      }
    }
  },

  pressPage: {
    backgroundColor: 'background'
  },

  // ? ========================
  // ? =======  blog   ========
  // ? ========================
  blogMenu: {
    padding: ['1rem', '1rem', '1rem', '1rem'],
    '.box': {
      backgroundColor: 'lightgrey'
    }
  },

  blogPage: {},

  // ? ========================
  // ? =====  services   ======
  // ? ========================

  servicesMenu: {
    '.menuSectionTitle': {
      display: 'none'
    },
    '.menuSectionDescription': {
      padding: '2rem',
      backgroundColor: 'primary',
      margin: '0rem 0rem 2rem',
      color: 'white'
    },
    '.menuItemContainer, .menuItemContainerImgActive': {
      width: ['100%', 'calc(50% - 1rem)', '', 'calc(25% - 1rem)'],
      margin: ['', '0.5rem', '', '0.5rem']
    },
    '.menuItemImageContainer': {
      display: 'block',
      padding: '0.25rem',
      border: 'solid 1px',
      borderColor: 'primary',
      borderRadius: '0px',
      img: {
        padding: '0.25rem'
      }
    },
    '.itemImageFill': {
      paddingBottom: '100%'
    },
    '.menuItemContentContainer': {
      zIndex: '1',
      '::before': {
        content: "''",
        border: 'solid 1px',
        borderColor: 'grey',
        width: 'calc(100% + 0.5rem)',
        height: 'calc(100% + 0.5rem)',
        position: 'absolute',
        left: '-0.25rem',
        top: '-0.25rem',
        zIndex: '-1'
      },
      position: 'relative',
      top: '-3rem',
      padding: '1rem',
      backgroundColor: 'grey',
      width: '90%',
      textAlign: 'center',
      margin: '0rem auto',
      backgroundColor: 'rgba(250, 248, 247, 0.9)',
      padding: '0.5rem'
    },
    '.menuItemName': {
      borderBottom: 'dashed 1px',
      paddingBottom: '0.5rem'
    },

    '.menuItemDescription': {
      fontSize: '0.8rem',
      width: '100%',
      textTransform: 'capitalize'
    }
  },

  buttonsGroup: {
    '.title': {
      display: 'none'
    },
    '.box': {
      alignItems: 'center'
    },
    '.ctaLink': {
      variant: 'buttons.secondary',
      margin: ' auto',
      fontWeight: 'bold',
      padding: '4rem 2rem',
      fontWeight: 'normal',
      letterSpacing: '1px',
      fontSize: ['1.5rem', '1.5rem', '1.5rem', '1.5rem'],
      height: '100%',
      textAlign: 'center',
      width: '100%'
    }
  }
}
